/**
 * Authentication utilities
 */
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import type { JWTPayload } from "./auth.types";

const TOKEN_COOKIE_NAME = "auth_token";
const COOKIE_EXPIRY_DAYS = 1; // Cookie expires in 1 day (token itself is 14 hours)

/**
 * Check if token is expired
 */
export const isTokenExpired = (token: string): boolean => {
  try {
    const decoded = jwtDecode<JWTPayload>(token);
    if (!decoded.exp) return true;
    
    const currentTime = Date.now() / 1000;
    return decoded.exp < currentTime;
  } catch {
    return true;
  }
};

/**
 * Decode JWT token and extract user info
 */
export const decodeToken = (token: string): JWTPayload | null => {
  try {
    return jwtDecode<JWTPayload>(token);
  } catch {
    return null;
  }
};

/**
 * Save token to cookie
 */
export const saveTokenToCookie = (token: string): void => {
  Cookies.set(TOKEN_COOKIE_NAME, token, {
    expires: COOKIE_EXPIRY_DAYS,
    sameSite: "strict",
    secure: window.location.protocol === "https:",
  });
};

/**
 * Get token from cookie
 */
export const getTokenFromCookie = (): string | null => {
  return Cookies.get(TOKEN_COOKIE_NAME) || null;
};

/**
 * Remove token from cookie
 */
export const removeTokenFromCookie = (): void => {
  Cookies.remove(TOKEN_COOKIE_NAME);
};

